import { AppPermissions } from 'constants/permissions';

export const permissions = {
  editApplication: [AppPermissions.change_accountapplication],
};
